import { useCallback, useEffect, useState } from "react";

export const ALLOW_LAB_REPORT_PRINT = "allowLabReportPrintOnDue";

const useAllowLabReportPrintOnDue = (): {
  allowLabReportPrintOnDue: boolean;
  toggleAllowLabReportPrintOnDue: () => void;
} => {
  const [allowLabReportPrintOnDue, setallowLabReportPrintOnDue] = useState(() => {
    const item = localStorage.getItem(ALLOW_LAB_REPORT_PRINT);
    return item === null ? true : JSON.parse(item);
  });

  useEffect(() => {
    localStorage.setItem(ALLOW_LAB_REPORT_PRINT, JSON.stringify(allowLabReportPrintOnDue));
  }, [allowLabReportPrintOnDue]);

  // for cross-tab changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === ALLOW_LAB_REPORT_PRINT) {
        setallowLabReportPrintOnDue(JSON.parse(e.newValue || "false"));
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const toggleAllowLabReportPrintOnDue = useCallback(() => {
    setallowLabReportPrintOnDue((prev) => !prev);
  }, []);

  return { allowLabReportPrintOnDue, toggleAllowLabReportPrintOnDue };
};

export default useAllowLabReportPrintOnDue;
